import { IInitState } from "../config/interfaces"

export const initState: IInitState = {
  firstName: "",
  lastName: "",
}
